import { Navigate } from 'react-router-dom';
import { isLoggedin } from '@/utils/auth';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  if (!isLoggedin()) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
